import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { register, getRegistrationStatus } from '../api';
import toast from 'react-hot-toast';
import { Zap, Lock } from 'lucide-react';
import Button from '../components/Button';

export default function Register() {
  const { loginUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name:'', email:'', password:'' });
  const [loading, setLoading] = useState(false);
  const [allowed, setAllowed] = useState(null); // null = checking

  useEffect(() => {
    getRegistrationStatus().then(r => setAllowed(!!r.allowed)).catch(() => setAllowed(false));
  }, []);

  const handle = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await register(form.name, form.email, form.password);
      loginUser(res.token, res.user);
      navigate('/');
    } catch (err) {
      toast.error(err?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-box">
        <div style={{ display:'flex', alignItems:'center', gap:11, marginBottom:26 }}>
          <div style={{ width:42, height:42, background:'var(--grad)', borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 8px 20px var(--accent-glow)' }}>
            <Zap size={20} color="#fff" />
          </div>
          <div>
            <div style={{ fontSize:16, fontWeight:700, color:'var(--text)' }}>WP Manager</div>
            <div style={{ fontSize:11, color:'var(--text3)' }}>Create your account</div>
          </div>
        </div>

        {allowed === false ? (
          <>
            <h2>Registration closed</h2>
            <p>New sign-ups are currently disabled for this dashboard.</p>
            <div style={{ display:'flex', alignItems:'center', gap:10, background:'var(--bg3)', border:'1px solid var(--border)', borderRadius:12, padding:'14px 16px', margin:'8px 0 18px' }}>
              <Lock size={18} color="var(--text3)" />
              <span style={{ fontSize:12.5, color:'var(--text2)' }}>Please contact the administrator if you need access.</span>
            </div>
            <p style={{ textAlign:'center', fontSize:12, color:'var(--text3)' }}>
              <Link to="/login" className="auth-link">Back to sign in</Link>
            </p>
          </>
        ) : (
          <>
            <h2>Get started</h2>
            <p>Create your dashboard account</p>

            <form onSubmit={handle}>
              <div className="field">
                <label>Full name</label>
                <input type="text" placeholder="Ahmed Khan" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} required />
              </div>
              <div className="field">
                <label>Email</label>
                <input type="email" placeholder="you@example.com" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} required />
              </div>
              <div className="field">
                <label>Password</label>
                <input type="password" placeholder="Min 8 characters" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} minLength={8} required />
              </div>
              <Button type="submit" className="btn primary" style={{ width:'100%', justifyContent:'center', marginTop:4 }} loading={loading} disabled={allowed === null}>
                {loading ? 'Creating account...' : 'Create account'}
              </Button>
            </form>

            <p style={{ marginTop:16, textAlign:'center', fontSize:12, color:'var(--text3)' }}>
              Already have an account? <Link to="/login" className="auth-link">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
